import { render, staticRenderFns } from "./BorderStylePreview.vue?vue&type=template&id=e509a78a&scoped=true"
import script from "./BorderStylePreview.vue?vue&type=script&lang=js"
export * from "./BorderStylePreview.vue?vue&type=script&lang=js"
import style0 from "./BorderStylePreview.vue?vue&type=style&index=0&id=e509a78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e509a78a",
  null
  
)

export default component.exports